export interface StarRatingFacetProps {
  value: string;
  applied: boolean;
  name: string;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  onChange: (arg0: any) => void;
  facetName: string;
  isMobile: boolean;
}

export enum StarSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}
